import * as sonbpIfconst from "../sonbpIf/base/constants";
import * as idbEdit from "../entity/idb/editInfo";
import * as idbOrder from "../entity/idb/orderInfo";
import * as es6promise from "es6-promise";
import { BaseLogicClass } from "./edit.baseLogic";
import { common, constDialogMessage, dialogUtil } from "../util";
import { util, GetEditInfo } from "..";
import { itemVenderProperty, sonbpIFContoroller } from "./edit.sonbp_if";
import { Logger } from "../util/logger";
import { EditConst, EDIT_MODE_KIND } from "./edit.const";
import { greetingTranEntityEx, photoFrame, uploadPhoto } from "./edit.entity";
import { editStrage } from "./edit.tool";
import * as edLogic from "./index";


/**
 * 保存関連の処理
 */
export class SaveLogicClass extends BaseLogicClass {

// #region ■定数・変数

    /**
     * 状態保存(WebAPI)呼び出しURL
     */
    private readonly WEBAPI_URL_SAVESTATE: string = "Edit/SaveState";

    private _photoLogic: edLogic.UploadImageLogic.PhotoLogicClass;
    private _myStampLogic: edLogic.UploadImageLogic.MyStampLogicClass;
    private _tegakiStampLogic: edLogic.UploadImageLogic.TegakiStampLogicClass;

// #endregion

// #region ■起動

    /**
     * 初期化
     * @override
     */
    public init(v: Vue, sonbpIf: sonbpIFContoroller, usePcDesign: boolean, authToken: string) {
        super.init(v, sonbpIf, usePcDesign, authToken);

        this._photoLogic = (<any>this._edctrl)._photoLogic;
        this._myStampLogic = (<any>this._edctrl)._myStampLogic;
        this._tegakiStampLogic = (<any>this._edctrl)._tegakiStampLogic;
    }

// #endregion

// #region ■イベント

    /**
     * 一時保存ボタン押下メソッド
     * */
    public btnClickSave(event: JQueryEventObject): void {

        this.saveReady(false, this.saveBody);
    }

// #endregion

// #region ■内部関数

    /**
     * 状態保存(WebAPI)呼び出し
     * @param authToken 認証トークン
     */
    public async saveState(authToken: string, senderInfo: GetEditInfo.GetEditInfoSenderEntity): es6promise.Promise<boolean> {

        let result: boolean = true;

        // 入力パラメータ
        const param = {
            sender: senderInfo,
            token: authToken
        }
        await util.ajax.post(this.WEBAPI_URL_SAVESTATE, JSON.stringify(param)).then((resData: any) => {

            Logger.debug("WebAPI_GetEditInfo  result[" + JSON.stringify(result) + "]");

        }).catch(() => {
            result = false;
        });

        return result
    }

    /**
     * 保存処理(準備)
     * @param switchParam   ：処理切り替え用フラグ
     * @param nextFunc      ：保存処理(＋α)本体
     */
    public async saveReady(switchParam: boolean, nextFunc: (that: any, setEditInfo: idbEdit.editInfo, senderInfo: GetEditInfo.GetEditInfoSenderEntity, switchParam: boolean) => void) {

        // ローディングダイアログ開始
        util.dialogUtil.showLoading();

        let that = this;

        // iDBから保存名取得
        //const editInfo: idbEdit.editInfo = await this.readiDBForEditInfo();
        const editInfo: idbEdit.editInfo = editStrage.readStorageForEditInfo();

        if (editInfo) {
            this._edctrl.editInfo.info.saveAs = editInfo.saveAs;
        }

        // 差出人情報収集
        let senderInfo: GetEditInfo.GetEditInfoSenderEntity = new GetEditInfo.GetEditInfoSenderEntity();
        {
            senderInfo = this.sonbpIfController.SenderInfo.sender;
        }

        let setEditInfo: idbEdit.editInfo = new idbEdit.editInfo();
        setEditInfo.retailerId = this._edctrl.RetailerConfig.id;
        setEditInfo.tempId = this._edctrl.editInfo.tempId;
        setEditInfo.photoList = [];
        setEditInfo.photoUseList = [];
        setEditInfo.greetingInfo = [];
        setEditInfo.stampInfo = [];
        setEditInfo.myStampList = [];
        setEditInfo.myStampUseList = [];
        setEditInfo.fontgenicList = [];
        setEditInfo.fontgenicUseList = [];
        setEditInfo.printType = this._vue.$data.FinishSelect.isGinen ? EditConst.PRINT_TYPE_GINEN : EditConst.PRINT_TYPE_PRINT;
        setEditInfo.saveAs = this._edctrl.editInfo.info.saveAs;
        setEditInfo.dsnNo = this._edctrl.editInfo.master.design.dsnNo;

        // 写真情報
        this._photoLogic.setSaveUploadInfo(this._photoLogic._uploadImageList, setEditInfo.photoList);
        // Myステッカー情報
        this._myStampLogic.setSaveUploadInfo(this._myStampLogic._uploadImageList, setEditInfo.myStampList);
        // 手書きスタンプ情報
        this._tegakiStampLogic.setSaveUploadInfo(this._tegakiStampLogic._uploadImageList, setEditInfo.fontgenicList);

        // sonbpから配置アイテムの情報収集
        this.sonbpIfController.getItems([],
            (list: itemVenderProperty[]) => {

                let existsSender: boolean = false;

                let createVpFunc = (list: itemVenderProperty): idbEdit.sonbpVp => {
                    let sonbpVp = new idbEdit.sonbpVp();
                    sonbpVp.idx = Number(list.idx);
                    sonbpVp.x = list.x
                    sonbpVp.y = list.y;
                    sonbpVp.width = list.w
                    sonbpVp.height = list.h
                    sonbpVp.angle = list.r;
                    return sonbpVp;
                };

                for (let i: number = 0; i < list.length; i++) {

                    if (list[i].item_type == sonbpIfconst.ITYPE_PHOTO_BOX) {
                        // 画像枠の場合
                        const selPf: photoFrame = util.relic.listFind(that.sonbpIfController.PhotoFrameList, (pf: photoFrame) => {
                            if (list[i].file_id === this.sonbpIfController.EMPTY_PHOTOBOX_FILE_ID) return false;
                            return pf.idx === list[i].idx;
                        });
                        if (selPf !== undefined) {
                            let setPhotoUse: idbEdit.photoUse = new idbEdit.photoUse();

                            setPhotoUse.fileId = selPf.fileId;
                            setPhotoUse.useI2 = selPf.useI2;
                            setPhotoUse.brightId = selPf.brightId;

                            setPhotoUse.sonbpVp = createVpFunc(list[i]);

                            setEditInfo.photoUseList.push(setPhotoUse);

                            //debug
                            console.debug("saveReady-photoUseList push.", setPhotoUse);
                        }
                    }
                    else if (list[i].item_type == sonbpIfconst.ITYPE_GREETING_TXT) {
                        // あいさつ文の場合
                        const selGreeting: greetingTranEntityEx = util.relic.listFind(that.sonbpIfController.GreetingList, (g: greetingTranEntityEx) => {
                            return g.id === list[i].idx;
                        });
                        if (selGreeting !== undefined) {

                            let setGreeting: idbEdit.greetingInfo = new idbEdit.greetingInfo();
                            setGreeting.id = Number(selGreeting.id);
                            setGreeting.greetingNo = selGreeting.greetingNo;
                            setGreeting.fontId = selGreeting.fontMaster.id;
                            setGreeting.size = selGreeting.size;
                            setGreeting.colorId = selGreeting.fontColorMaster.id;
                            if (selGreeting.outlineChar) {
                                setGreeting.outlineColor = selGreeting.outlineFontColorMaster.id;
                            }
                            setGreeting.align = selGreeting.align;
                            setGreeting.direction = selGreeting.direction;
                            setGreeting.text = selGreeting.text;

                            setGreeting.sonbpVp = createVpFunc(list[i]);

                            setEditInfo.greetingInfo.push(setGreeting);
                        }
                    }
                    else if (list[i].item_type == sonbpIfconst.ITYPE_SENDER_TXT) {
                        // 差出人の場合
                        senderInfo.x = list[i].x;
                        senderInfo.y = list[i].y;
                        senderInfo.rotate = list[i].r;

                        existsSender = true;
                    }
                    else if (list[i].item_type == sonbpIfconst.ITYPE_STAMP_IMG) {
                        // スタンプの場合
                        let setStamp = new idbEdit.stampInfo();

                        setStamp.fileId = list[i].file_id;
                        setStamp.sonbpVp = createVpFunc(list[i]);

                        setEditInfo.stampInfo.push(setStamp);
                    } else if (list[i].item_type == sonbpIfconst.ITYPE_MYSTAMP_IMG) {
                        // Myステッカーの場合
                        let setMyStamp = new idbEdit.uploadStampUseInfo();

                        setMyStamp.fileId = list[i].file_id;
                        setMyStamp.sonbpVp = createVpFunc(list[i]);

                        setEditInfo.myStampUseList.push(setMyStamp);
                    }
                    else if (list[i].item_type == sonbpIfconst.ITYPE_FONTGENIC_IMG) {
                        // 手書きスタンプの場合
                        let setStamp = new idbEdit.uploadStampUseInfo();

                        let fileIdParts = list[i].file_id.split('@');
                        setStamp.fileId = fileIdParts[0];
                        setStamp.colorId = fileIdParts[1];
                        setStamp.sonbpVp = createVpFunc(list[i]);

                        setEditInfo.fontgenicUseList.push(setStamp);
                    }
                }

                if (!existsSender) {
                    // 差出人情報オブジェクトが存在しない場合は、空保存にする
                    senderInfo = new GetEditInfo.GetEditInfoSenderEntity();
                }

                // 登録処理へ
                nextFunc(that, setEditInfo, senderInfo, switchParam);
            },
            () => {
            });
    }

    /**
     * 保存処理(本体)：次へ or 一時保存用
     * @param that          ：this
     * @param setEditInfo   ：iDBへの保存内容
     * @param senderInfo    ：サーバへの保存内容
     * @param switchParam   ：true：次ページへ遷移、false：一時保存遷移
     */
    public async saveBody(that: SaveLogicClass, setEditInfo: idbEdit.editInfo, senderInfo: GetEditInfo.GetEditInfoSenderEntity, switchParam: boolean) {

        Logger.debug("保存処理 indexedDBに保存 開始");

        // indexedDBに保存
        //const result: boolean = await that.writeiDB(setEditInfo);
        const result: boolean = editStrage.writeStorage(that._edctrl.editInfo, setEditInfo);

        // 結果判定
        if (result) {
            Logger.debug("保存処理 sonbp PDF保存 開始");

            // sonbp PDF保存
            await that.sonbpIfController.save(
                () => {
                    // 正常終了の場合
                    Logger.debug("現在の状態を保存するWebAPI呼び出し 開始", senderInfo);

                    // 現在の状態を保存するWebAPI呼び出し
                    that.saveState(that._authToken, senderInfo).then((result: boolean) => {
                        if (result) {
                            // ローディングダイアログ終了
                            util.dialogUtil.closeLoading();
                            // 処理分岐
                            if (switchParam) {
                                // 画面遷時は、sessionStorageに書き込まない
                                that._edctrl.doUnloadEventFunc = false;

                                Logger.debug("プレビュー画面へ遷移 開始");
                                // プレビュー画面へ遷移
                                util.ui.postRedirect(EditConst.NEXTPAGE_NAME);
                            }
                            else {
                                Logger.debug("一時保存処理 開始");

                                // orderInfoは空オブジェクトで渡す                                
                                const orderInfo: idbOrder.orderInfo = new idbOrder.orderInfo();

                                // 一時保存実行
                                util.common.SaveData(that._authToken, setEditInfo, orderInfo).then((value: any) => {
                                    Logger.debug("一時保存処理 正常終了", value);
                                });
                            }
                        }
                        else {
                            throw new Error("saveState return false.");
                        }
                    }).catch((err: any) => {
                        Logger.error("状態保存処理 エラー終了", err);
                        // ローディングダイアログ終了
                        util.dialogUtil.closeLoading();
                        util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_SAVE_DATA, util.dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
                    });
                },
                () => {
                    // 異常終了の場合
                    Logger.error("保存処理 sonbp PDF保存 エラー終了");
                    // ローディングダイアログ終了
                    util.dialogUtil.closeLoading();
                    util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_SAVE_DATA, util.dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
                });
        }
        else {
            Logger.error("保存処理 indexedDBに保存 失敗");
            // ローディングダイアログ終了
            util.dialogUtil.closeLoading();
            util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_SAVE_DATA, util.dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
        }
    }

    /**
     * 戻るボタンのリンクを取得する。
     * callbackURLがあればそれに、無ければリテーラconf
     * */
    private getEditReturnURL(): string {
        const callBack = decodeURIComponent($('#CallBackURL').val());
        if (!callBack) {
            return this._edctrl.RetailerConfig.editReturnBtn;
        }
        return callBack;
    }

    /**
     * 保存処理(本体)：デザイン選択画面へ戻る用
     * @param that          ：this
     * @param setEditInfo   ：iDBへの保存内容
     * @param senderInfo    ：サーバへの保存内容
     * @param switchParam   ：確認ダイアログ表示切り替えフラグ(true：表示、false：非表示)
     */
    public async saveBodyForReturnFlow(that: SaveLogicClass, setEditInfo: idbEdit.editInfo, senderInfo: GetEditInfo.GetEditInfoSenderEntity, switchParam: boolean) {

        Logger.debug("保存処理 indexedDBに保存 開始");

        // indexedDBに保存
        //const result: boolean = await that.writeiDB(setEditInfo);
        const result: boolean = editStrage.writeStorage(that._edctrl.editInfo, setEditInfo);
        // 結果判定
        if (result) {
            // ローディングダイアログ終了
            util.dialogUtil.closeLoading();

            Logger.debug("離脱時のダイアログ表示");
            // 離脱時のダイアログ表示
            const saveName: string = common.GetSaveAs();

            // ダイアログのモード
            const isEdit = saveName ? true : false;
            const token = that._authToken;

            // デザイン選択ページに移動処理
            const goDesignPage = function () {

                // 画面遷時は、sessionStorageに書き込まない
                that._edctrl.doUnloadEventFunc = false;

                dialogUtil.closeCautionSelectSaveMethodDialog();
                window.location.href = that.getEditReturnURL();
            }

            // 上書き時の処理
            const overRideFunc = function () {
                dialogUtil.closeCautionSelectSaveMethodDialog();

                dialogUtil.showLoading();
                that.sonbpIfController.save(
                    () => {
                        common.DoSaveOverRide(token, saveName, goDesignPage);
                    },
                    () => {
                        // 異常終了の場合
                        Logger.error("保存処理 sonbp PDF保存 エラー終了");
                        // ローディングダイアログ終了
                        util.dialogUtil.closeLoading();
                        util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_SAVE_DATA, util.dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
                    }
                );
            }

            // 名前を付けて保存の処理
            const saveFunc = function () {
                dialogUtil.closeCautionSelectSaveMethodDialog();

                dialogUtil.showLoading();
                that.sonbpIfController.save(
                    () => {
                        common.DoSave(token, goDesignPage);
                    },
                    () => {
                        // 異常終了の場合
                        Logger.error("保存処理 sonbp PDF保存 エラー終了");
                        // ローディングダイアログ終了
                        util.dialogUtil.closeLoading();
                        util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_SAVE_DATA, util.dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
                    }
                );
            }

            // 表示制御
            if (switchParam) {
                // ログインチェック
                common.LoginCheck(token).then((clientId: string) => {

                    Logger.debug("ログインチェック OK [" + clientId + "]");

                    if (clientId) {
                        // ログイン状態
                        dialogUtil.createCautionSelectSaveMethodDialog(isEdit, true, overRideFunc, saveFunc, goDesignPage);
                    } else {
                        // 上記以外の場合
                        dialogUtil.createCautionSelectSaveMethodDialog(isEdit, false, overRideFunc, saveFunc, goDesignPage);
                    }
                }).catch(() => {
                    Logger.debug("ログインチェック NG");
                    // ログインチェック失敗時
                    dialogUtil.createCautionSelectSaveMethodDialog(isEdit, false, overRideFunc, saveFunc, goDesignPage);
                });
            }
            else {
                // 表示しないで遷移
                goDesignPage();
            }
        }
        else {
            Logger.error("保存処理 indexedDBに保存 失敗");
            // ローディングダイアログ終了
            util.dialogUtil.closeLoading();
            util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_SAVE_DATA, util.dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
        }
    }

// #endregion

}
